// extracted by mini-css-extract-plugin
export default {"item":"Item_item__zgr4T","itemTitle":"Item_itemTitle__-tJ-2","content":"Item_content__IVtgL","text":"Item_text__CDzPm"};